import { camelizeJSON, snakeCaseJSON } from './transform_json'
import LocationPathHelper from './location_path_helper'
import fetch from 'fetch-retry'
import { readCookie } from './cookie_helper'

class RequestHelper {
  static getToken() {
    this.token = this.token || readCookie('csrf_token')
    return this.token
  }

  static getHeaders() {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRFToken': this.getToken(),
    }
  }

  static getJSONHeaders() {
    return Object.assign(
      {
        'Content-Type': 'application/json',
        Accept: 'application/json, */*',
      },
      this.getHeaders()
    )
  }

  // Fetches camelized JSON
  static fetchCamelizedJSON(action, options) {
    return this.fetchJSON(action, {
      camelize: true,
      snakeCasedRequest: true,
      ...options,
    })
  }

  static getUrlWithParams(action, queryParams, { snakeCasedRequest } = {}) {
    let url = action
    let fetchQueryParams = queryParams
    if (fetchQueryParams) {
      if (snakeCasedRequest) {
        fetchQueryParams = snakeCaseJSON(fetchQueryParams)
      }
      const params = LocationPathHelper.stringifyParams(fetchQueryParams)
      url += (url.indexOf('?') === -1 ? '?' : '&') + params
    }

    return url
  }

  // Takes the action URL and options that can either take data || body (data preferred),
  // Allows override of method and headers
  // Returns promise that resolves with JSON object
  // NOTE: If calling to EXTERNAL API, override headers with at least {}
  static fetchJSON(action, options) {
    const { camelize, headers } = options
    const shouldReturnCamelized = (json) =>
      camelize ? camelizeJSON(json) : json
    let isError = false
    if (!headers) {
      options.headers = this.getJSONHeaders() // eslint-disable-line no-param-reassign
    }

    return this.fetchResponse(action, options)
      .then((response) => {
        if (!response.ok) {
          isError = true
        }
        return response.text()
      })
      .then((text) => {
        try {
          return JSON.parse(text)
        } catch (e) {
          return {}
        }
      })
      .then((json) => {
        if (isError) {
          throw json
        }
        return json
      })
      .then(shouldReturnCamelized)
  }

  static fetchResponse(
    action,
    { data, body, headers, method = 'POST', queryParams, snakeCasedRequest }
  ) {
    let fetchData = data
    let fetchHeaders = headers
    let fetchQueryParams = queryParams

    if (!fetchData) {
      fetchData = body
    }
    if (!fetchHeaders) {
      fetchHeaders = this.getHeaders()
    }

    if (snakeCasedRequest) {
      fetchData = snakeCaseJSON(fetchData)
      fetchQueryParams = snakeCaseJSON(queryParams)
    }

    if (typeof data !== 'string') {
      fetchData = JSON.stringify(fetchData)
    }

    const url = this.getUrlWithParams(action, fetchQueryParams)

    return fetch(url, {
      method,
      credentials: 'include',
      headers: fetchHeaders,
      body: fetchData,
      retryOn: [503, 504],
    })
  }
}

export default RequestHelper
